/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import {
  Route,
  Switch,
  useHistory,
  useParams
} from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { Grid, Typography } from '@material-ui/core';
// Graco dependencies
import BranchPage from './TlmBranch/BranchPage.jsx';
import BranchSettingsPage from './TlmBranch/BranchSettingsPage.jsx';
import SitePage from './TlmSite/SitePage.jsx';
import SiteSettingsPage from './TlmSite/SiteSettingsPage.jsx';
import TankPage from './TlmTank/TankPage.jsx';
import TankSettingsPage from './TlmTank/TankSettingsPage.jsx';
import { host } from "../data";
import { useTranslation } from 'react-i18next';

// Routes incoming urls to the appropriate view page with necessary state based on url
const PageRouter = ({ orgInfo, branchInfo, siteInfo, resetSiteData, resetBranchData }) => {
  return (
    <Switch>
      <Route exact path='/orgs/:orgName/branches/:branchName'>
        <BranchPage
          orgInfo={orgInfo}
          branchInfo={branchInfo}
          siteInfo={siteInfo} /></Route>
      <Route exact path='/orgs/:orgName/branches/:branchName/edit'>
        <BranchSettingsPage orgInfo={orgInfo}
          branchInfo={branchInfo}
          resetBranchData={resetBranchData} /></Route>
      <Route exact path='/orgs/:orgName/branches/:branchName/sites/:siteName'>
        <SitePage orgInfo={orgInfo}
          branchInfo={branchInfo}
          siteInfo={siteInfo} /></Route>
      <Route exact path='/orgs/:orgName/branches/:branchName/new'>
        <SiteSettingsPage orgInfo={orgInfo}
          branchInfo={branchInfo}
          siteInfo={null}
          resetSiteData={resetSiteData} /></Route>
      <Route exact path='/orgs/:orgName/branches/:branchName/sites/:siteName/edit'>
        <SiteSettingsPage orgInfo={orgInfo}
          branchInfo={branchInfo}
          siteInfo={siteInfo}
          resetSiteData={resetSiteData} /></Route>
      <Route exact path='/orgs/:orgName/branches/:branchName/sites/:siteName/tanks/:tankName'>
        <TankPage orgInfo={orgInfo}
          branchInfo={branchInfo}
          sitesNavDict={siteInfo.sitesNavDict} /></Route>
      <Route exact path='/orgs/:orgName/branches/:branchName/sites/:siteName/new'>
        <TankSettingsPage orgInfo={orgInfo}
          branchInfo={branchInfo}
          sitesNavDict={siteInfo.sitesNavDict} /></Route>
      <Route exact path='/orgs/:orgName/branches/:branchName/sites/:siteName/tanks/:tankName/edit'>
        <TankSettingsPage orgInfo={orgInfo}
          branchInfo={branchInfo}
          sitesNavDict={siteInfo.sitesNavDict} /></Route>
      <Route path='/'>
        <BranchPage orgInfo={orgInfo}
          branchInfo={branchInfo}
          siteInfo={siteInfo} /></Route>
    </Switch>
  );
}

// Main TlmPage component. Loads high level state and routes the page.
export default function TlmPage({ orgInfo }) {
  const { t } = useTranslation();
  // Get history for redirecting pages
  const history = useHistory();
  // Get params so we can read the url path parameters
  const params = useParams();
  // Create state for the current branch and available branches
  const [branches, setBranch] = React.useState({
    branchName: '',
    isBranchEditor: true,
    isBranchViewer: true,
    branchId: null,
    branchList: [],
    branchNavDict: {}
  });
  const [branchesFetched, setBranchesFetched] = React.useState(false);
  // Create state for the list of sites
  const [sites, setSites] = React.useState({
    sitesList: [],
    siteData: [],
    sitesNavDict: {}
  });
  const [sitesFetched, setSitesFetched] = React.useState(false);

  // Gets and sets the branch data. Triggers when org state or path changes.
  React.useEffect(() => {
    fetchBranchData();
  }, [orgInfo]);

  function fetchBranchData(targetBranch) {
    // console.log(targetBranch);
    Auth.currentAuthenticatedUser()
      .then(data => {
        var requestOptions = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': data.signInUserSession.idToken.jwtToken
          }
        };

        console.log("Fetching branches...");

        fetch(host + '/orgs/' + orgInfo.orgId
          + '/branches', requestOptions)
          .then(results => results.json())
          .then(data => {
            console.log("Branches fetched.");
            // If no branch exists, send the user to the branch creation page.
            if (data.default.branchName.trim() === "") {
              console.log("No branches found.");
              let url = '/orgs/'.concat(orgInfo.orgName).concat('/branches');
              history.push(url);
            }
            else {
              setBranchesFetched(true);
              if (targetBranch !== undefined && data.data.branchesNavDict[targetBranch] !== undefined) {
                setBranch({
                  branchName: targetBranch,
                  isBranchEditor: data.data.branchesNavDict[targetBranch][1],
                  isBranchViewer: data.data.branchesNavDict[targetBranch][2],
                  branchId: data.data.branchesNavDict[targetBranch][0],
                  branchList: data.data.branchesList,
                  branchNavDict: data.data.branchesNavDict
                });
                let url = '/orgs/' + orgInfo.orgName + '/branches/' + targetBranch;
                console.log(url);
                history.push(url);
              }
              else if (params.branchName !== undefined &&
                params.branchName !== data.default.branchName &&
                data.data.branchesNavDict[params.branchName] !== undefined) {

                setBranch({
                  branchName: params.branchName,
                  isBranchEditor: data.data.branchesNavDict[params.branchName][1],
                  isBranchViewer: data.data.branchesNavDict[params.branchName][2],
                  branchId: data.data.branchesNavDict[params.branchName][0],
                  branchList: data.data.branchesList,
                  branchNavDict: data.data.branchesNavDict
                });
              }
              else {
                setBranch({
                  branchName: data.default.branchName,
                  isBranchEditor: data.default.isBranchEditor,
                  isBranchViewer: data.default.isBranchViewer,
                  branchId: data.default.branchId,
                  branchList: data.data.branchesList,
                  branchNavDict: data.data.branchesNavDict
                });
              }
            }
          }).catch((error) => {
            console.log(error);
          });
      });
  }

  // Get the site info. Triggers when the branch info updates.
  React.useEffect(() => {
    // Only run AFTER the branches have been fetched.
    fetchSiteData();
  }, [branches]);

  function fetchSiteData(targetSite) {
    // Only run AFTER the branches have been fetched.
    if (branchesFetched) {
      setSitesFetched(false);
      Auth.currentAuthenticatedUser()
        .then(data => {
          var requestOptions = {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': data.signInUserSession.idToken.jwtToken
            }
          };

          console.log("Fetching sites...")
          fetch(host + '/orgs/' + orgInfo.orgId
            + '/branches/' + branches.branchId
            + '/sites', requestOptions)
            .then(results => results.json())
            .then(data => {
              console.log("Sites fetched.");
              setSites({
                sitesList: data.data.sitesList,
                siteData: data.data.json_data,
                sitesNavDict: data.data.sitesNavDict
              });
              if (targetSite !== undefined && data.data.sitesNavDict[targetSite] !== undefined) {
                let url = { pathname: ('/orgs/').concat(orgInfo.orgName).concat('/branches/').concat(branches.branchName).concat('/sites/').concat(targetSite) };
                history.push(url);
              }
              setSitesFetched(true);
            }).catch((error) => {
              console.log(error);
            });
        })
    }
  }
  // When the url changes, this confirms we're on the correct branch.
  React.useEffect(() => {
    if (params.branchName !== undefined &&
      params.branchName !== branches.branchName &&
      branches.branchNavDict[params.branchName] !== undefined) {
      setBranch({
        branchName: params.branchName,
        isBranchEditor: branches.branchNavDict[params.branchName][1],
        isBranchViewer: branches.branchNavDict[params.branchName][2],
        branchId: branches.branchNavDict[params.branchName][0],
        branchList: branches.branchList,
        branchNavDict: branches.branchNavDict
      });
    }
  }, [params]);

  return (
    <>
      {branchesFetched
        ? sitesFetched
          ? <PageRouter
            resetSiteData={fetchSiteData}
            resetBranchData={fetchBranchData}
            orgInfo={orgInfo}
            branchInfo={branches}
            siteInfo={sites} />
          : <Grid item>
            <Typography align="center">
              {t("loadingSiteData")}
            </Typography>
          </Grid>
        : <Grid item>
          <Typography align="center">
            {t("loadingBranchData")}
          </Typography>
        </Grid>}
    </>
  )
}
